export const SEARCH_ORDERS = 'SEARCH_ORDERS';
export const SEARCH_SUBSCRIPTIONS = 'SEARCH_SUBSCRIPTIONS';
export const SEARCH_TICKETS = 'SEARCH_TICKETS';
export const SEARCH_PARTNER_PLATFORM_HISTORICAL_TICKETS = 'SEARCH_PARTNER_PLATFORM_HISTORICAL_TICKETS';
export const SEARCH_KB = 'SEARCH_KB';
export const SEARCH_MACROS = 'SEARCH_MACROS';
export const SEARCH_ALL = 'SEARCH_ALL'; // Ticket, KB, and Macro search
export const MACRO_WIZARD = 'MACRO_WIZARD';
export const SEARCH_CANCEL_SUBSCRIPTIONS_DECISION_TREE = 'SEARCH_CANCEL_SUBSCRIPTIONS_DECISION_TREE'; // not a tab, just a result type
export const SEARCH_ORDERS_DECISION_TREE = 'SEARCH_ORDERS_DECISION_TREE';
export const SEARCH_CANCELLATIONS_DECISION_TREE = 'SEARCH_CANCELLATIONS_DECISION_TREE';
export const SEARCH_RETURNS_DECISION_TREE = 'SEARCH_RETURNS_DECISION_TREE';
export const SEARCH_RBI_STORES = 'SEARCH_RBI_STORES';

export const NON_TABLE_SEARCH_OPTIONS = [
  SEARCH_CANCEL_SUBSCRIPTIONS_DECISION_TREE,
  SEARCH_ORDERS_DECISION_TREE,
  SEARCH_MACROS,
  SEARCH_KB,
  SEARCH_TICKETS,
  SEARCH_RETURNS_DECISION_TREE,
];

const DELETEABLE_SEARCH_TYPES = [SEARCH_TICKETS, SEARCH_KB];
export const isDeleteEnabledForSearchType = (searchType) => {
  return DELETEABLE_SEARCH_TYPES.indexOf(searchType) > -1;
};

// used for analytics tracking
export const convertSearchTypeToResultType = (searchType) => {
  switch (searchType) {
    case SEARCH_MACROS:
      return 'MACRO';
    case SEARCH_KB:
      return 'KB_ARTICLE';
    case SEARCH_TICKETS:
      return 'HISTORICAL_TICKETS';
    default:
      return null;
  }
};
